<template>
  <section class="layer-section sku-number">
    <h3 class="section-title">数量</h3>
    <div class="section-content count">
      <div class="btn-wrapper">
        <div class="section-btn">
          <p class="name">{{ number }}</p>
          <span class="minus" :class="{ disabled: number <= 1 }" @click="addNum(false)">
            <i class="icon icon-minus"></i>
          </span>
          <span class="add" :class="{ disabled: number >= maxNum }" @click="addNum(true)">
            <i class="icon icon-plus"></i>
          </span>
        </div>
      </div>
      <p class="purchase-tip" v-if="skuInfo.commodityDepositeVo">一次只能购买一件哦</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'sku-number',
  props: {
    skuInfo: Object,
    number: Number,
    maxNum: Number
  },
  methods: {
    // 调整购买数量
    addNum(isAdd) {
      // 至少购买一件
      if (!isAdd && this.number <= 1) {
        // do nothing
      } else if (isAdd && this.number >= this.maxNum) {
        this.$toast(`商品最多只能选中${this.maxNum}个`)
        // 数量不能超过后台规定数量
      } else {
        this.$emit('numberChange', isAdd ? this.number + 1 : this.number - 1)
      }
      // 点击埋点
      this.$emit('numberClick', {
        num: this.number,
        type: isAdd ? 1 : 0
      })
    }
  }
}
</script>
